<template>
  <v-row>
    <!-- kitchen sink -->
    <v-col cols="12">
      <app-card-code
        :title="`${$t('menu.products')} / ${$t('menu.jsonAirport')}`"
      >
        <AirportImport></AirportImport>
      </app-card-code>
    </v-col>
  </v-row>
</template>

<script>
// eslint-disable-next-line import/no-unresolved
import AppCardCode from '@/@core/components/app-card-code/AppCardCode.vue'

import AirportImport from './form/AirportImport.vue'

export default {
  components: {
    AppCardCode,
    AirportImport,
  },
}
</script>
